export interface IndexerUrls {
  coreUrl: string;
  votesUrl: string;
  errorsUrl: string;
}

export const fetchIndexerUrls = async (baseUrlCdn: string): Promise<IndexerUrls> => {
  const response = await fetch(baseUrlCdn);

  if (!response.ok) {
    throw new Error(`Failed to fetch base URLs config: ${response.status} ${response.statusText}`);
  }

  const config = await response.json();

  if (!config.base_indexer_url) {
    throw new Error('base_indexer_url not found in configuration');
  }

  const baseIndexerUrl = config.base_indexer_url.replace(/\/$/, '');

  return {
    coreUrl: `${baseIndexerUrl}/core/graphql`,
    votesUrl: `${baseIndexerUrl}/votes/graphql`,
    errorsUrl: `${baseIndexerUrl}/errors/graphql`,
  };
};
